// extracted by mini-css-extract-plugin
export default {"buttonLoader":"FloButton_buttonLoader__IoBpj","success":"FloButton_success__Cuq8h","danger":"FloButton_danger__8ZHWy","secondary":"FloButton_secondary__mzWag"};